const server = 'https://portal.tacna.net/' //PROD
// const server = 'http://10.147.20.150:4444/' //DEV Fausto
// const server = 'http://dev.tacna.net:1212/' //DEV Jesus
// const server = 'https://test.tacna.net/' //Test
//const server = 'http://10.147.20.150:1213/' //DEV Carlos
// const server = 'https://dev.tacna.net/' //Juan Pi


export const BASE_URL = server
export const URL_EXPORT_CSV = `${server}internal_api/export_csv`
export const URL_CUSTOM_REPORT = `${server}report_custom/`

